import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { AlertsTimelineData, Skeleton } from "../interfaces/CommonInterfaces";

export default function AlertOverview({ alertsline, loading }: { alertsline: AlertsTimelineData[], loading: boolean }) {
  return (
    <Card className="h-full lg:col-span-2">
      <CardHeader>
        <CardTitle>Alerts Overview</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-center h-64">
          {loading ? (
            // Skeleton placeholder
            <Skeleton className="w-full h-64 rounded-md" />
          ) : alertsline && alertsline.length > 0 ? (
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={alertsline}>
                <CartesianGrid strokeDasharray="3 3" className="opacity-30" />
                <XAxis
                  dataKey="date"
                  axisLine={false}
                  tickLine={false}
                  tick={{ fontSize: 12 }}
                  className="text-muted-foreground"
                />
                <YAxis
                  axisLine={false}
                  tickLine={false}
                  tick={{ fontSize: 12 }}
                  className="text-muted-foreground"
                />
                <Tooltip
                  labelFormatter={(label) => `Date: ${label}`}
                  formatter={(value) => [value, 'Alerts']}
                />
                <Area
                  type="monotone"
                  dataKey="alerts"
                  stroke="hsl(var(--primary))"
                  fill="hsl(var(--primary) / 0.2)"
                  strokeWidth={2}
                  isAnimationActive={false}
                />
              </AreaChart>
            </ResponsiveContainer>
          ) : (
            <div className="w-full text-sm text-center text-muted-foreground">
              No data found.
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
